import ServiceDocumentWizardPage from "./ServiceDocumentWizardPage";

export default ServiceDocumentWizardPage;